// src/config/brand.ts
import thirtyDaysLoan from "./30daysloan.com.json";
import fundsMamaDotCom from "./fundsmama.com.json";
import fundsMamaDotIn from "./fundsmama.in.json";

const BRAND = process.env.REACT_APP_BRAND;

const brandMap = {
  "30daysloan.com": thirtyDaysLoan,
  "fundsmama.com": fundsMamaDotCom,
  "fundsmama.in": fundsMamaDotIn
};

if (!BRAND || !brandMap[BRAND]) {
  throw new Error(`Invalid or missing brand: ${BRAND}`);
}

export const BRAND_CONFIG = brandMap[BRAND];
//30dayslon.com
// "accessCode": "AVNV49MA85CG74VNGC",
    // "workingKey": "B021D3750831A80BE683F525B4FE76DC",
      // "redirectUrl": "https://pg.fundsmama.com/ccavResponseHandler30daysloan",

//fundsmama.com

//fundsmama.in 
